import { AbstractControl, UntypedFormGroup, ValidationErrors } from '@angular/forms';
import { Utility } from '../utils/utility';

export function PtpDateAndAmountValidator(form: AbstractControl): ValidationErrors | null {
  if (!(form instanceof UntypedFormGroup)) return null;

  const ptpDateControl = form.get('ptp_date');
  const ptpAmountControl = form.get('ptp_amount');

  const ptpDate = ptpDateControl?.value;
  const ptpAmount = ptpAmountControl?.value;
  const amountNum = Number(ptpAmount);
  const isPTPAmountValid = (amountNum > 0 && amountNum <= 1000000);//return true when value >0 && <=1000000
  const isPTPDateValid = Utility.isFutureDate(ptpDate);

  // Reset ptp_amount errors
  let amountErrors: any = {};
  // Validate ptp_amount
  if (ptpAmount !== '' && !isPTPAmountValid) {
    amountErrors.invalidRange = true;//ptp amount value(including 0) and out of range
  }
  else if (ptpDate && isPTPDateValid && ptpAmount === '') {
    amountErrors.invalidRequired = true;//ptp date valid and ptp amount blank('')
  }
  ptpAmountControl?.setErrors(Object.keys(amountErrors)?.length ? amountErrors : null);

  // Validate ptp_date
  let dateErrors: any = {};
  if (ptpDate && !isPTPDateValid) {
    dateErrors.invalidPTPDate = true;//ptp date in past excluding today date
  }
  else if (isPTPAmountValid && !ptpDate) {
    dateErrors.invalidPTPDateRequired = true;
  }
  ptpDateControl?.setErrors(Object.keys(dateErrors)?.length ? dateErrors : null);

  return null;
}
